import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const addressUrl = process.env.REACT_APP_ADDRESS_URL;
const backendurl=process.env.REACT_APP_BACKEND_URL

export const fetchStates = async (setData) => {
  try {
    await axios.get(`${addressUrl}/unique_districts`).then((res) => setData(res.data));
  } catch (error) {
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
};

export const fetchSubDistrict = async (district, setData) => {
  try {
    await axios.get(`${addressUrl}/sub_districts?district=${encodeURIComponent(district)}`).then((res) => setData(res.data));
  } catch (error) {
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
};

export const getPincodeData=async(pinCode,setData,handleErrOpen,setErrMes)=>{
  try {
    await axios.get(`${addressUrl}/get_pincode_data`,{
      params:{
        pincode:pinCode
      }
    })
    .then((res) =>
       setData(res.data));
  } catch (error) {
    console.log(error);
    handleErrOpen()
    setErrMes(error.response?error.response.data.error:'Something went wrong')
    console.clear()
    TokenLogout(error)
  }
}

export const ReturnPincodeData=async(pinCode)=>{
  try {
    const res=await axios.get(`${addressUrl}/get_pincode_data`,{
      params:{
        pincode:pinCode
      }
    })
    return res.data
  } catch (error) {
    console.log(error);
    console.clear()
    TokenLogout(error)
  }
}
// console.log(backendurl);

export const fetchPincode=async(pinCode,setData,handleErrOpen,setErrMes,setBackdropOpen)=>{
  try {
    setBackdropOpen(true)
    await axios.post(`${backendurl}/products/check_location_access`,{pincode:pinCode},{
      params:{

      },
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res) =>{
      setBackdropOpen(false)
      if(res.data.approved_status===true){
        getPincodeData(pinCode,setData,handleErrOpen,setErrMes);
      }
      else{
        setErrMes("Not authorized to onboard agents in this location");
        handleErrOpen();
      }
    });
  } catch (error) {
    setBackdropOpen(false)
    console.log(error);
    setErrMes(error.response?error.response.data.error:'Something went wrong')
    handleErrOpen();
    console.clear()
    TokenLogout(error)
  }
}

export const fetchPincodeWithoutAccess=async(pincode,setData,setFieldValue)=>{
  try {
    await axios.get(`${addressUrl}/get_pincode_data`,{
      params:{
        pincode:pincode
      }
    })
    .then((res) =>{
      setData(res.data)
      // setFieldValue(res.data.)
      setFieldValue("branch_state",res.data[0].State)
      setFieldValue("branch_district",res.data[0].District)
    }

  );
  } catch (error) {
    console.log(error);
    console.clear()
    TokenLogout(error)
  }
}


export const PostNonFIApplication=async(data,PincodeData,setIsLoading,handleAlertOpen)=>{
  console.log("data",data);

  try{
    setIsLoading(true)
    await axios.post(`${backendurl}/products/non_fi_onboarding_via_tm`,{
      "customer_name": data.name,
      "customer_mobile": data.mobile_number,
      "customer_email": data.email_address,
      "retail_address": data.address,
      "retail_state":PincodeData[0].State,
      "retail_district":PincodeData[0].District,
      "retail_pincode": parseInt(data.pincode),
      "retail_village": data.retail_village,
      "service_type": data.type_of_service
  },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res)=>{
      setIsLoading(false)
      handleAlertOpen(res.data.message,'success')
      let token=sessionStorage.getItem('token');
      let UserType=sessionStorage.getItem('UserType');
      let isLoggedin=sessionStorage.getItem('isLoggedin');
      let userName=sessionStorage.getItem('UserName');
      sessionStorage.clear()
      sessionStorage.setItem('token',token)
      sessionStorage.setItem('UserType',UserType)
      sessionStorage.setItem('isLoggedin',isLoggedin)
      sessionStorage.setItem('UserName',userName)
      setTimeout(()=>{
          window.location.href="/dashboard/default"
        },2000)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear()
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong",'error')

    TokenLogout(error)
  }
}

export const PostAecApplication=async(data,product_id,PincodeData,setIsLoading,handleAlertOpen)=>{
  console.log("data",data);

  try{
    setIsLoading(true)
    await axios.post(`${backendurl}/products/non_fi_onboarding_via_tm`,{
      "customer_name": data.name,
      "customer_mobile": data.mobile_number,
      "customer_email": data.email_address,
      "retail_address": data.address,
      "retail_state":PincodeData[0].State,
      "retail_district":PincodeData[0].District,
      "retail_pincode": parseInt(data.pincode),
      "retail_village": data.retail_village,
      "service_type": data.type_of_service,
      "product_id": product_id
  },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res)=>{
      setIsLoading(false)
      handleAlertOpen(res.data.message,'success')
      let token=sessionStorage.getItem('token');
      let UserType=sessionStorage.getItem('UserType');
      let isLoggedin=sessionStorage.getItem('isLoggedin');
      let userName=sessionStorage.getItem('UserName');
      sessionStorage.clear()
      sessionStorage.setItem('token',token)
      sessionStorage.setItem('UserType',UserType)
      sessionStorage.setItem('isLoggedin',isLoggedin)
      sessionStorage.setItem('UserName',userName)
      setTimeout(()=>{
          window.location.href="/dashboard/default"
        },2000)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear()
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong",'error')

    TokenLogout(error)
  }
}


export const postPaymentLink=async(data,setErrMes,setErrType,setErr,handleClose,setIsLoading)=>{
  console.log(data);
  try{
    setIsLoading(true);
    await axios.post(`${backendurl}/products/send_payment_link`,{
      "customer_name": data.name,
      "customer_mobile": data.mobile_number,
      "customer_email": data.email_address,
      "total_amount":data.total,
      "product_id": data.product_id,
      "device_id":data.device_id,
      "retail_address": data.address,
      "retail_state":data.kiosk_state,
      "retail_district":data.kiosk_district,
      "retail_sub_district":data.kiosk_sub_district,
      "retail_pincode": parseInt(data.pincode),
      "retail_village": data.retail_village,
      "service_type": data.type_of_service,
      "payment_type": data.payment_type,
      "device_amount":data.device_amount,
      "agreement_amount":data.agreement_amount,
      "payment_category":data.category
  },{
    headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
    }
  }).then((res)=>{
    let token=sessionStorage.getItem('token');
    let UserType=sessionStorage.getItem('UserType');
    let isLoading=sessionStorage.getItem('isLoggedin')
    let userName=sessionStorage.getItem('UserName')
    sessionStorage.clear()
    sessionStorage.setItem('token',token)
    sessionStorage.setItem('isLoggedin',isLoading)
    sessionStorage.setItem('UserType',UserType)
    sessionStorage.setItem('UserName',userName)

        console.log(res);
        setErrType('success')
        setErrMes(res.data.message)
        setErr(true)
        setTimeout(()=>{
          handleClose();
          setIsLoading(false)
          if(UserType!=='ds'){
            window.location.href="/Admin/payment_status";
          }
          else{
            window.location.href="/dashboard/default"
          }
        },1500)
    })
  }
  catch(error){
    setIsLoading(false)
    setErrMes(error.response&&error.response.data.error&&typeof error.response.data.error==='string'?error.response.data.error:"Something went wrong")
    setErrType('error')
    setErr(true)
    TokenLogout(error)
  }
}


export const postDsPayment=async(data,setErrMes,setErrType,setErr,handleClose,setIsLoading)=>{
  console.log(data);
  try{
    setIsLoading(true);
    await axios.post(`${backendurl}/products/send_payment_link`,{
      "customer_name": data.name,
      "customer_mobile": data.mobile_number,
      "customer_email": data.email_address,
      "total_amount":data.total,
      "part_amount":data.partial_payment,
      "signon_part_amount":data.signon_part_amount,
      "hardware_part_amount":data.hardware_part_amount,
      "product_id": data.product_id,
      "due_date":data.due_date,
      "device_id":data.device_id,
      "retail_address": data.address,
      "retail_state":data.kiosk_state,
      "retail_district":data.kiosk_district,
      "retail_sub_district":data.kiosk_sub_district,
      "retail_pincode": parseInt(data.pincode),
      "retail_village": data.retail_village,
      "service_type": data.type_of_service,
      "payment_type": data.payment_type,
      "device_amount":data.device_amount,
      "agreement_amount":data.agreement_amount,
      "payment_category":data.category
  },{
    headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
    }
  }).then((res)=>{
    let token=sessionStorage.getItem('token');
    let UserType=sessionStorage.getItem('UserType');
    let isLoading=sessionStorage.getItem('isLoggedin')
    let userName=sessionStorage.getItem('UserName')
    sessionStorage.clear()
    sessionStorage.setItem('token',token)
    sessionStorage.setItem('isLoggedin',isLoading)
    sessionStorage.setItem('UserType',UserType)
    sessionStorage.setItem('UserName',userName)

        console.log(res);
        setErrType('success')
        setErrMes("Payment link generated successfully")
        setErr(true)
        setTimeout(()=>{
          handleClose();
          setIsLoading(false)
          if(UserType!=='ds'){
            window.location.href="/Admin/payment_status";
          }
          else{
            window.location.href="/dashboard/default"
          }
        },1500)
    })
  }
  catch(error){
    setIsLoading(false)
    setErrMes(error.response&&error.response.data.error&&typeof error.response.data.error==='string'?error.response.data.error:"Something went wrong")
    setErrType('error')
    setErr(true)
    TokenLogout(error)
  }
}


export const postPartPaymentLink=async(data,type,setErrMes,setErrType,setErr,handleClose,setIsLoading)=>{
  console.log(data);
  try{
  setIsLoading(true)
    await axios.post(`${backendurl}/products/send_payment_link`,{
      "customer_name": data.name,
      "customer_mobile": data.mobile_number,
      "customer_email": data.email_address,
      "total_amount":data.total,
      "product_id": data.product_id,
      "due_date":data.due_date,
      "device_id":data.device_id,
      "signon_part_amount":data.signon_part_amount,
      "hardware_part_amount":data.hardware_part_amount,
      "retail_address": data.address,
      "retail_pincode": parseInt(data.pincode),
      "retail_village": data.retail_village,
      "retail_state":data.kiosk_state,
      "retail_district":data.kiosk_district,
      "retail_sub_district":data.kiosk_sub_district,
      "service_type": data.type_of_service,
      "payment_type": data.payment_type,
      "part_amount":data.partial_payment,
      "remarks":data.remarks,
      "device_amount":data.device_amount,
      "agreement_amount":data.agreement_amount,
      "payment_category":data.category
  },{
    headers:{
              Authorization:`Bearer ${sessionStorage.getItem('token')}`
    }
  }).then((res)=>{
    let token=sessionStorage.getItem('token');
    let UserType=sessionStorage.getItem('UserType');
    let isLoading=sessionStorage.getItem('isLoggedin')
    let UserName=sessionStorage.getItem('UserName')
    sessionStorage.clear()
    sessionStorage.setItem('token',token)
    sessionStorage.setItem('isLoggedin',isLoading)
    sessionStorage.setItem('UserType',UserType)
    sessionStorage.setItem('UserName',UserName)
    console.log(res);
    setErrType('success')
    setErrMes(res.data.message)
    setErr(true)
    setTimeout(()=>{
      handleClose();
      setIsLoading(false)
      if(UserType!=='ds'){
        window.location.href="/Admin/payment_status";
      }
      else{
        window.location.href="/dashboard/default"
      }
    },1500)
  })
  }
  catch(error){
    setIsLoading(false)
    setErrMes(error.response&&error.response.data.error&&typeof error.response.data.error==='string'?error.response.data.error:"Something went wrong")
    setErrType('error')
    setErr(true)
    TokenLogout(error)
  }
}

//second installment
export const postSecondPaymentLink=async(data,setErrMes,setErrType,setErr,setIsLoading)=>{
  console.log(data);
  try{
  setIsLoading(true)
    await axios.post(`${backendurl}/products/send_payment_link`,{
      "installment_type":"installment_2",
      "request_id":data._id
  },{
    headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
    }
  }).then((res)=>{
    window.location.reload()
    setIsLoading(false)
        console.log(res);
        console.clear()
        setErrType('success')
        setErrMes(res.data.message)
        setErr(true)

    })

  }
  catch(error){
    setIsLoading(false)
    setErrMes("Something went wrong")
    setErrType('error')
    setErr(true)
    TokenLogout(error)
  }
}

export const getAllPayments=async(page,filter,setState,setIsLoading)=>{
  console.log("filter",filter);

  try{
    setIsLoading(true)
    await axios.post(`${backendurl}/products/get_payment_list`,{
      agent_name:filter.name===''?null:filter.name,
      agent_mobile:filter.mobile_number===''?null:filter.mobile_number,
      bank_name:filter.bank===''?null:filter.bank,
      payment_type:filter.mode_of_paymnet===''?null:filter.mode_of_paymnet,
      payment_status:filter.payment_status===''?null:filter.payment_status,
      page:page,
      limit:10
    },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      },

    }).then((res)=>{
      setIsLoading(false)
      setState(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
  finally{
    setIsLoading(false)
  }
}

export const getPartPayments=(setState,setIsLoading,setError)=>{
  try{
    setIsLoading(true)
    axios.get(`${backendurl}/products/get_request_list`,{
      headers:{
                Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    }).then((res)=>{
      setIsLoading(false)
      setState(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      setError(error.response?error.response.data.error:'somthing went wrong')
      console.clear();
      TokenLogout(error)

    })
  }
  catch(error){
    setIsLoading(false)
    setError(error.response?error.response.data.error:'somthing went wrong')
    TokenLogout(error)
  }
}

export const checkPaymentStatus=(Data,setIsLoading,setAlertMessage,setAlertType,setAlertOpen,getAllPayments,setData,setIsDataLoading)=>{
  try{
    setIsLoading(true)
    axios.post(`${backendurl}/products/check_payment_status`,{
      "from_date":Data.payment_details.installment_2?Data.payment_details.installment_2.created_date:Data.payment_details.installment_1.created_date,
      "invoice_id":Data.payment_details.installment_2?Data.payment_details.installment_2.invoice_id:Data.payment_details.installment_1.invoice_id,
      "page_number":"1",
      request_id:Data._id
    },{
      headers:{
                Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    }).then((res)=>{
      setIsLoading(false)
      if(res.data.payment_status==="successful"){
        console.log("1");
        setAlertMessage(res.data.message)
        setAlertType('success')
        setAlertOpen(true)
        setTimeout(()=>{
          window.location.reload()
          getAllPayments(null,setData,setIsDataLoading)
        },1500)
      }
      else if(res.data.payment_status==="pending"){
        console.log("2");

        setAlertMessage(res.data.message)
        setAlertType('warning')
        setAlertOpen(true)
      }
      else if(res.data.payment_status==='aborted'){
        console.log("3");
        setAlertMessage(res.data.message)
        setAlertType('error')
        setAlertOpen(true)
        setTimeout(()=>{
          getAllPayments(null,setData,setIsDataLoading)
        },1500)
      }
      else{
        console.log("4");
        setAlertMessage(res.data.message)
        setAlertType('error')
        setAlertOpen(true)

        // console.log(res);
      }

    })
    .catch(err=>{
      setIsLoading(false)
      setAlertMessage(err.response?err.response.data.error:"Something went wrong")
      setAlertType('error')
      setAlertOpen(true)
      // console.log(err);
      console.clear();
      TokenLogout(err)
    })
  }
  catch(error){
    setAlertMessage(error.response?error.response.data.error:"Something went wrong")
    setAlertType('error')
    setAlertOpen(true)
    setIsLoading(false)
    TokenLogout(error)
    // console.log(error);
  }
}



export const getPaymentForCodeCreation=(requestId,setData,setIsLoading,handleAlertOpen)=>{
    try{
      axios.post(`${backendurl}/products/fetch_payment_details`,{request_id:requestId},{
        headers:{
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res)=>{
        setIsLoading(false)
        setData(prevState => ({
          ...prevState,
          "payment_data": { ...prevState.payment_data, "payment_details": res.data }
        }));

      })
    }
    catch(error){
      setIsLoading(false)
      handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
      TokenLogout(error)
      // console.log("error at fetch",error);

    }
}

export const checkPaymentStatusAtCodeCreation=(Data,setIsLoading,handleAlertOpen,setStateData)=>{
  console.log("Data",Data);

  try{
    setIsLoading(true)
    axios.post(`${backendurl}/products/check_payment_status`,{
      "from_date":Data.payment_details.installment_2?Data.payment_details.installment_2.created_date:Data.payment_details.installment_1.created_date,
      "invoice_id":Data.payment_details.installment_2?Data.payment_details.installment_2.invoice_id:Data.payment_details.installment_1.invoice_id,
      "page_number":"1",
      request_id:Data._id
    },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    }).then((res)=>{
      setIsLoading(false)
      if(res.data.payment_status==="successful"){
        console.log("1");
        handleAlertOpen(res.data.message,"success")
        setTimeout(()=>{
          window.location.reload()
        },2000)

      }
      else if(res.data.payment_status==="pending"){
        console.log("2");
        handleAlertOpen(res.data.message,"warning")


      }
      else if(res.data.payment_status==='aborted'){
        console.log("3");
        handleAlertOpen(res.data.message,"error")

      }
      else{
        console.log("4");
        handleAlertOpen(res.data.message,"error")
        // console.log(res);
      }

    })
    .then(()=>{
      getPaymentForCodeCreation(Data._id,setStateData,setIsLoading,handleAlertOpen)
    })
    .catch(err=>{
      setIsLoading(false)
      handleAlertOpen(err.response&&err.response.data.error?err.response.data.error:"Something went wrong","error")
      getPaymentForCodeCreation(Data._id,setStateData,setIsLoading,handleAlertOpen)

      // console.log(err);
      // console.clear();
      TokenLogout(err)
    })
  }
  catch(error){
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    setIsLoading(false)
    TokenLogout(error)
    getPaymentForCodeCreation(Data._id,setStateData,setIsLoading,handleAlertOpen)
    console.log(error);
  }
}

export const FetchDynamicStateName=(setData,setIsLoading)=>{
  try{
    setIsLoading(true)
    axios.get(`${addressUrl}/iob_master/state_list`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    }).then((res)=>{
      setIsLoading(false)
      setData(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
}

export const FetchDynamicRegion=(setData,setIsLoading,state)=>{
  try{
    setIsLoading(true)
    axios.get(`${addressUrl}/iob_master/region_list`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      },
      params:{
        "state_name":state
      }
    }).then((res)=>{
      setIsLoading(false)
      setData(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
}

export const FetchDynamicDistrict=(setData,setIsLoading,region)=>{
  try{
    setIsLoading(true)
    axios.get(`${addressUrl}/iob_master/district_list`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      },
      params:{
        "region_code":region
      }
    }).then((res)=>{
      setIsLoading(false)
      setData(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
}


export const FetchDynamicBranch=(setData,setIsLoading,district)=>{
  try{
    setIsLoading(true)
    axios.get(`${addressUrl}/iob_master/branch`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      },
      params:{
        "district_code":district
      }
    }).then((res)=>{
      setIsLoading(false)
      setData(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
}

export const FetchDynamicSubDistrict=(setData,setIsLoading,district)=>{
  try{
    setIsLoading(true)
    axios.get(`${addressUrl}/iob_master/sub_district_list`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      },
      params:{
        "code":district
      }
    }).then((res)=>{
      setIsLoading(false)
      setData(res.data)
    })
    .catch((error)=>{
      setIsLoading(false)
      TokenLogout(error)
    })
  }
  catch(error){
    setIsLoading(false)
    console.log(error);
    console.clear();
    TokenLogout(error)
  }
}

export const PostResendLink=async(id,setIsLoading,handleAlertOpen,handleClose)=>{
  try{
    setIsLoading(true)
    await axios.post(`${backendurl}/products/resend_payment_link`,{
      payment_id:id
    },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res)=>{
      setIsLoading(false)
      handleAlertOpen(res.data.message,"success")
      handleClose()
      setTimeout(()=>{
        window.location.reload()
      },1500)
      // console.log(res);
    })

  }
  catch(error){
    setIsLoading(false)
    // console.log(error);
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    
    handleClose()
    TokenLogout(error)
  }
}

export const PostResendLinkAtCodeCreation=async(id,setIsLoading,handleAlertOpen,handleClose,setStateData)=>{
  try{
    setIsLoading(true)
    await axios.post(`${backendurl}/products/resend_payment_link`,{
      payment_id:id
    },{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res)=>{
      setIsLoading(false)
      handleAlertOpen(res.data.message,"success")
      getPaymentForCodeCreation(id,setStateData,setIsLoading,handleAlertOpen)
      handleClose()
      // console.log(res);
    })

  }
  catch(error){
    setIsLoading(false)
    // console.log(error);
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    handleClose()
    TokenLogout(error)
  }
}

export const postSecondPaymentLinkAtCodeCreation=async(data,setErrMes,setErrType,setErr,setIsLoading,setStateData,handleAlertOpen)=>{
  console.log(data);
  try{
  setIsLoading(true)
    await axios.post(`${backendurl}/products/send_payment_link`,{
      "installment_type":"installment_2",
      "request_id":data._id
  },{
    headers:{
        Authorization:`Bearer ${sessionStorage.getItem('token')}`
    }
  }).then((res)=>{
    // window.location.reload()
    setIsLoading(false)
        console.log(res);
        console.clear()
        setErrType('success')
        setErrMes(res.data.message)
        setErr(true)

        getPaymentForCodeCreation(data._id,setStateData,setIsLoading,handleAlertOpen)

    })

  }
  catch(error){
    setIsLoading(false)
    setErrMes("Something went wrong")
    setErrType('error')
    setErr(true)
    TokenLogout(error)
  }
}